import React, { useEffect, useState } from 'react'
import { useFlash } from 'spa/hooks/useFlash'
import FlashType from 'javascripts/layouts/v2/FlashType'
import LazyImg from 'javascripts/common/LazyImg'
import CSSModules from 'react-css-modules'
import styles from './style.module.scss'
import { ClientGlobalStyles } from 'spa/client/styles/GlobalStyles'
import CrowdWorksCompanyName from 'spa/client/components/CrowdWorksCompanyName'

import logo from 'images/clients/login/logo.png'

interface ClientLoginPageProps {
  flash?: FlashType
}

const ClientLoginLayout: React.FC<ClientLoginPageProps> = CSSModules<React.FC<ClientLoginPageProps>>((props) => {
  const [flash, setFlash] = useFlash(props.flash)
  const [flashClass, setFlashClass] = useState<string>(null)
  const flashMessage = flash?.success || flash?.notice || flash?.alert || flash?.error

  useEffect(() => {
    setFlash({ ...flash, ...props.flash })
    setFlashClass('-show')
  }, [props.flash])
  useEffect(() => {
    const interval = setInterval(() => {
      setFlashClass(null)
    }, 5000)

    return () => clearInterval(interval)
  }, [])

  return (
    <>
      <ClientGlobalStyles />
      <header styleName='client-login-header'>
        <div>
          <div styleName='description'>法人向けエンジニア・デザイナーの業務委託採用</div>
          <LazyImg styleName='logo' src={logo} alt={'クラウドワークス エージェント'} />
        </div>
      </header>
      <main styleName='main'>
        <div styleName='flash-container'>
          {flashMessage ? <div styleName='flash' className={flashClass}>{flashMessage}</div> : null}
        </div>
        {props.children}
      </main>
      <footer styleName='client-login-footer'>
        <LazyImg styleName='logo' src={logo} alt={'クラウドワークス エージェント'} />
        <div styleName='copyright'>copyright (c) CrowdWorks Inc. all rights reserved. 運営会社：<CrowdWorksCompanyName /></div>
      </footer>
    </>
  )
}, styles)

export default ClientLoginLayout
